import React from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const WhyRentSection = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center text-center min-h-[70vh] w-full">
      <div className="flex flex-col items-center justify-center w-full px-4">
        <h3 className="text-base tracking-widest text-white font-semibold mb-6 uppercase opacity-80">
          Ready to drive?
        </h3>
        <h1 className="text-4xl md:text-6xl font-bold max-w-4xl text-white mb-8 leading-tight">
          Experience Luxury, On
          <br className="hidden md:block" /> Your Terms
        </h1>
        <p className="text-lg md:text-xl text-white max-w-2xl mb-10 opacity-90">
          Step into the world of elite driving. With Luzurio, your perfect car
          is just a few clicks away — fast booking, flawless service,
          unforgettable journeys.
        </p>
        <ButtonPrimary onClick={()=>{navigate("/vehicles")}} className="bg-primary-100 text-[#121212] font-semibold text-lg px-10 py-4 rounded-full transition shadow-lg">
          Browse Our Cars
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default WhyRentSection;
